export default __webpack_public_path__ + "static/media/add_icon.d8d16485.svg";